import BaseApi from '@/api/Base/BaseApi'
import {
  CreateInquiryPayload,
  GetInquiryListPayload,
  GetInquiryListResponse,
  SendInquiryMessagePayload,
  getInquiryDetailResponse, GetFileDownloadTokenPayload, GetFileDownloadTokenResponse
} from '@/api/Inquiry/types'

const ROOT = '/admin/inquiry'

export default class InquiryApi extends BaseApi {
  createInquiry(payload: CreateInquiryPayload) {
    const { workspaceId, type, title, content, files } = payload
    const formData = new FormData()
    formData.append('type', type)
    formData.append('title', title)
    formData.append('content', content)
    files.forEach((f) => {
      formData.append('file', f)
    })
    return this.agent.post(`/workspace/${workspaceId}/inquiry`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  getInquiryList(payload?: GetInquiryListPayload) {
    const {
      itemsPerPage = 50,
      page = 0,
      keyword,
      sortKey,
      sortDir,
      status,
      type,
      searchType,
    } = payload ?? {}
    return this.agent.get<GetInquiryListResponse>('/admin/inquiries', {
      params: {
        page,
        num_per_page: itemsPerPage,
        search: keyword,
        sort_key: sortKey,
        sort_dir: sortDir,
        status,
        type,
        searchType,
      },
    })
  }

  getInquiryDetail(inquiryId: string) {
    return this.agent.get<getInquiryDetailResponse>(`${ROOT}/${inquiryId}`)
  }

  sendInquiryMessage(payload: SendInquiryMessagePayload) {
    const { inquiryId, ...rest } = payload
    return this.agent.post(`${ROOT}/${inquiryId}/answer`, rest)
  }

  saveTempInquireAnswer(payload: SendInquiryMessagePayload) {
    const { inquiryId, ...rest } = payload
    return this.agent.post(`${ROOT}/${inquiryId}/typing-answer`, rest)
  }

  getDownloadToken(payload: GetFileDownloadTokenPayload) {
    const { inquiryId, fileId } = payload
    return this.agent.get<GetFileDownloadTokenResponse>(`/inquiry/${inquiryId}/download-token/${fileId}`)
  }
}
